import createAxiosClient from "../../clients/axiosClient";

const getProductStockDetails = async productCode => {
  try {
    const helpUiAxiosClient = await createAxiosClient();

    const response = await helpUiAxiosClient.get(
      `${process.env.NEXT_PUBLIC_API_DOMAIN}/self-serve/orders/bff/stock/v1/products/${productCode}`,
    );
    return response.data;
  } catch (err) {
    return null;
  }
};
export default getProductStockDetails;
